<template>
  <div>
    <Dialog
      id="'dialog-profile-signature'"
      :visible="show"
      @update:visible="$emit('close')"
      :style="{ width: $isMobile() ? '100vw' : '40vw', position: 'relative' }"
      v-bind:class="[{ 'p-dialog-maximized': $isMobile() }]"
      :modal="true"
      :closable="false"
      :header="'Selecionar ficheiro PAT #' + patId"
    >
        <Loading :active.sync="loading" :isFullPage="false"></Loading>
        <Toast />
        <div class="p-d-flex p-flex-wrap">
            <div v-for="file in filteredFiles" :key="file.id">
                <span
                class="p-d-flex p-ai-center p-flex-column p-mb-4 p-mr-4"
                >
                <span class="p-mb-2 label-file">{{ getLabel(file) }}</span>

                <template v-if="isPdf(file)">
                  <div class="pdf-preview">
                    <i class="pi pi-file-pdf" style="font-size: 4rem; color: #e74c3c;"></i>
                    <small class="p-mt-1">{{ file.resume || file.id }}.pdf</small>
                  </div>
                </template>

                <template v-else>
                <ImagePreview
                    v-if="file.file"
                    :src="getImageSource(file)"
                    height="150"
                    fileServiceMethod="getStorageFile"
                    class="p-mr-2"
                />

                <AuthenticatedImage
                    v-else
                    :file="file.filepath"
                    height="250"
                    fileServiceMethod="getStorageFile"
                    class="p-mr-2"
                />
                </template>

                <div class="p-mt-2 p-d-flex p-flex-wrap">
                    <Button
                        :label="isFileSelected(file) ? 'Selecionado' : 'Selecionar'"
                        :icon="isFileSelected(file) ? 'pi pi-check-circle' : 'pi pi-check'"
                        :class="isFileSelected(file) ? 'p-button-sm p-button-secondary p-mr-2' : 'p-button-sm p-button-success p-mr-2'"
                        @click="toggleFileSelection(file)"
                    />
                </div>
                </span>
            </div>
        </div>
        <template #footer>
            <Button
                :disabled="isSaveDisabled"
                :label="'Guardar'"
                icon="pi pi-save"
                class="p-button-success"
                @click="saveSelectedFile"
            />

            <Button
                label="Fechar"
                icon="pi pi-times"
                class="p-button-danger"
                @click="close"
            />
        </template>
    </Dialog>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import PatService from "@/services/pat.service";
import AuthenticatedImage from "@/components/elements/AuthenticatedImage.vue";

export default {
  name: "DialogPatFiles",
props: {
    show: {
        type: Boolean,
        default: false
    },
    multiple: {
        type: Boolean,
        default: false
    },
    patId: {
        type: Number,
        required: true
    }
  },
  watch: {
    async show() {
      if (this.show === true) {
        await this.getFiles()

      } else {
        this.close();
      }
    },
  },
  components: { Loading, AuthenticatedImage },
  data() {
    return {
      showAddFileForm: false,
      loading: false,
      files: [],
      selectedFile: null,
      selectedFiles: []
    };
  },
  computed: {
    filteredFiles() {
      return this.files.filter(file => {
        const extension = (file.extension || '').toLowerCase();
        return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff', 'svg', 'webp', 'pdf'].includes(extension);
      });
    },
    isSaveDisabled() {
      return this.multiple ? this.selectedFiles.length === 0 : this.selectedFile == null;
    }
  },
  methods: {
    async getFiles() {
      this.showAddFileForm = false;
      this.loading = true;
      this.files = await PatService.getFiles(this.patId);

      this.loading = false;
    },

    close() {
      this.showAddFileForm = false;
      this.files = [];
      this.loading = false;
      this.selectedFile = null;
      this.selectedFiles = [];
      this.$emit('close')
    },

    toggleFileSelection(file) {
      if (!this.multiple) {
        this.selectedFile = file;
        return;
      }

      const exists = this.selectedFiles.some(selected => selected.id === file.id);

      if (exists) {
        this.selectedFiles = this.selectedFiles.filter(selected => selected.id !== file.id);
        return;
      }

      this.selectedFiles.push(file);
    },

    isFileSelected(file) {
      if (this.multiple) {
        return this.selectedFiles.some(selected => selected.id === file.id);
      }

      return this.selectedFile?.id === file.id;
    },

    saveSelectedFile() {
      this.$emit('file-selected', this.multiple ? this.selectedFiles : this.selectedFile);
      this.close();
    },

    getImageSource(file) {
      return `data:image/${file.extension};base64,${file.file}`;
    },

    isPdf(file) {
      return file.extension && file.extension.toLowerCase() === 'pdf';
    },

    getLabel(file) {
      const resume = (file.resume || '').toLowerCase();
      if (resume.includes("label")) {
        return "Foto da etiqueta";
      } else if (resume.includes("breakdown")) {
        return "Foto da avaria";
      } else if (resume.includes("pop")) {
        return "Foto POP";
      }
      return `Outros | ${file.resume || file.id}`;
    },

    openFullscreen(id) {
      const element = document.getElementById(id);
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    },
  }
};
</script>

<style scoped>
.label-file {
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}
.pdf-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 150px;
  height: 150px;
  border: 1px dashed #ccc;
  border-radius: 4px;
  background: #fafafa;
}
</style>
